import { useActiveOrganization } from "@/core/context/ActiveOrganizationContext"
import Relay from "@/relay/relayUtils"
import { MembersProfileFieldFilterDropdownQuery } from "@components/dropdown/profile-field/__generated__/MembersProfileFieldFilterDropdownQuery.graphql"
import MembersProfileFieldFilter, {
  MembersProfileFieldFilterProps,
} from "@components/dropdown/profile-field/MembersProfileFieldFilter"
import DiscoPaginatedDropdown, {
  DiscoPaginatedDropdownSkeleton,
} from "@disco-ui/dropdown/DiscoPaginatedDropdown"
import { TestIDProps } from "@utils/typeUtils"
import { useLazyLoadQuery } from "react-relay"
import { graphql } from "relay-runtime"

type Props = TestIDProps & MembersProfileFieldFilterProps

function MembersProfileFieldFilterDropdown({
  testid = "MembersProfileFieldFilterDropdown",
  ...contentProps
}: Props) {
  const activeOrganization = useActiveOrganization()

  const { organization } = useLazyLoadQuery<MembersProfileFieldFilterDropdownQuery>(
    graphql`
      query MembersProfileFieldFilterDropdownQuery(
        $id: ID!
        $isPrivate: Boolean
        $webFormQuestionTypes: [WebFormQuestionType!]
      ) {
        organization: node(id: $id) {
          ... on Organization {
            id
            profileFields(
              status: visible
              defaultTypesToExclude: [email_address, public_groups]
              isPrivate: $isPrivate
              webFormQuestionTypes: $webFormQuestionTypes
            ) {
              totalCount
            }
          }
        }
      }
    `,
    {
      id: activeOrganization?.id || "",
      isPrivate: contentProps.isPrivate,
      webFormQuestionTypes: contentProps.webFormQuestionTypes,
    },
    { fetchPolicy: "network-only" }
  )

  if (!organization?.profileFields?.totalCount) return null

  return (
    <DiscoPaginatedDropdown
      testid={testid}
      title={"Profile Fields"}
      icon={"tag"}
      content={<MembersProfileFieldFilter {...contentProps} />}
    />
  )
}

function MembersProfileFieldFilterDropdownSkeleton() {
  return <DiscoPaginatedDropdownSkeleton />
}

export default Relay.withSkeleton({
  component: MembersProfileFieldFilterDropdown,
  skeleton: MembersProfileFieldFilterDropdownSkeleton,
})
